export enum DisclaimerRateTypeEnum {
  CONTRACT = 'CONTRACT',
  INTERLINE = 'INTERLINE',
  PROMO = 'PROMO',
}
